module.exports = __webpack_public_path__ + "img/icon-star.a35b58af.svg";